import axios from 'axios';
import { encryptData } from '../utils/helpers';
// import jwt from 'jsonwebtoken';

const {
  VUE_APP_API_URL,
  VUE_APP_API_CHECKOUT,
  VUE_APP_API_PLATFORM,
  VUE_APP_VERSION,
  VUE_APP_ENV,
  NODE_ENV,
} = process.env;

const checkoutUrl = VUE_APP_API_CHECKOUT;
const nodeUrl = `${VUE_APP_API_PLATFORM}/endpoints`;
const profileUrl = `${VUE_APP_API_PLATFORM}/profile`;
const nodeTicketingUrl = `${VUE_APP_API_PLATFORM}/ticketing`;
const s3Url = 'https://cdn.';
const graphApi = `${VUE_APP_API_PLATFORM}/graphql/graphql`;
const apiConfigs = `${VUE_APP_API_PLATFORM}/configs`;
const hashVersion = VUE_APP_VERSION;
const node = NODE_ENV;
axios.defaults.baseURL = VUE_APP_API_URL;

// const signToken = payload => jwt.sign(payload, 'jnputin');
const getToken = () => new Promise((res) => {
  // if (window && window.grecaptcha) {
  //   window.grecaptcha.ready(() => {
  //     window.grecaptcha.execute(process.env.VUE_APP_GOOGLE_RECAPCHA_SITE_KEY).then((token) => res(token));
  //   });
  // }
  res('joinnus4ever')
});

class Api {
  constructor() {
    this.axios = axios;
    this.apiUrl = VUE_APP_API_URL;
    this.checkoutUrl = checkoutUrl;
    this.profileUrl = axios.create({
      baseURL: `${profileUrl}/v1`,
      timeout: 30000,
    });
    this.nodeUrl = nodeUrl;
    this.nodeTicketingUrl = nodeTicketingUrl;
    this.graphApi = graphApi;
    this.nodeApi = axios.create({
      baseURL: nodeUrl,
    });
    this.apiConfigs = axios.create({
      baseURL: `${apiConfigs}/v1/joinnus`,
      timeout: 30000,
    });
  }

  async reactiveTicket(payload, session, slug = 'joinnus') {
    const headers ={ cookie_joinnus: session };
    const { data } = await this.axios.post(`${this.nodeTicketingUrl}/v1/${slug}/ticketing/ticket/reactivate`, payload , { headers });
    return data;
  }

  async getTransactionsTickets(token, payload) {
    try {
      const headers = token ? { Authorization: token } : {};
      const { data } = await axios.get(`${this.apiUrlAccount}/event/${payload.eventId}/qr-codes`, { headers });
      return data;
    } catch (error) {
      return error;
    }
  }

  async login(payload, headers) {
    const { data } = await this.axios.post('/auth/login', payload, { headers, withCredentials: true });
    return data;
  }

  async refreshSession() {
    try {
      const payload = {
        session: this.token,
        user_id: this.userAuth.id,
      };
      const { data } = await this.axios.post('/auth/refresh-session', payload);
      if (data.sessionId) {
        this.token = data.sessionId;
        this.userAuth.token = data.sessionId;
        this.userAuth.expire = data.expire;
        this.userAuth.expireTimestamp = data.expireTimestamp;
      }
      return data;
    } catch (error) {
      return { status: false, message: 'Error refresh session.' };
    }
  }

  async register(payload) {
    const { data } = await this.axios.post('/auth/signup', payload);
    return data;
  }

  async forgetPassword(payload) {
    try {
      const { data } = await this.axios.post('/account/forget-password', payload);
      return data;
    } catch (e) {
      return { status: false, message: 'Error inesperado.' };
    }
  }

  async getDataEvent(eventId) {
    // const { data } = await this.axios.get(`/PE/events/${eventId}`);
    const { data } = await this.axios.get(`${this.nodeUrl}/PE/events/${eventId}`);
    if (!data.status) return false;
    return data.data;
  }

  async getDataEventJSON(eventId) {
    // const { data } = await this.axios.get(`/PE/events/${eventId}`);
    const { data } = await this.axios.get(`${s3Url}joinnus.com/files_cache/detail_${eventId}.json?v=${hashVersion}`);
    if (!data.status) return false;
    return data.data;
  }

  async getData() {
    // const { data } = await this.axios.get(`/PE/events/${eventId}`);
    delete axios.defaults.headers.common.Authorization;
    const { data } = await this.axios.get(`${s3Url}joinnus.com/files_cache/events.json?v=${hashVersion}`);
    // if (data.status !== 200) return false;
    return data;
  }

  async getMarkersJSON() {
    // const { data } = await this.axios.get(`/PE/events/${eventId}`);
    delete axios.defaults.headers.common.Authorization;
    const { data } = await this.axios.get(`${s3Url}joinnus.com/files_cache/markings.json?v=${hashVersion}`);
    // if (data.status !== 200) return false;
    return data;
  }

  async getDataTypesJSON(eventId, hourId) {
    // const { data } = await this.axios.get(`/PE/events/${eventId}`);
    const { data } = await this.axios.get(
      `${s3Url}joinnus.com/files_cache/types_${eventId}_${hourId}.json?v=${hashVersion}`,
    );
    return data;
  }

  async getDataTypes(eventId, hourId) {
    const { data } = await this.axios.get(
      `${this.nodeUrl}/ticket-types?activityId=${eventId}&dateHourId=${hourId}&fov=all`,
    );
    if (!data.status) return false;
    return data.data;
  }

  // eslint-disable-next-line class-methods-use-this
  getDataEventJSONURL(eventId, hash = hashVersion) {
    return `${s3Url}joinnus.com/files_cache/detail_${eventId}.json?v=${hash}`;
  }

  // eslint-disable-next-line class-methods-use-this
  getSectionsJSONURL(eventId) {
    return `${s3Url}joinnus.com/files_cache/sections_${eventId.toLowerCase()}.json?v=${hashVersion}`;
    // return `/sections_vibra.json`;
  }

  // eslint-disable-next-line class-methods-use-this
  getDataTypesJSONURL(eventId, hourId) {
    return `${s3Url}joinnus.com/files_cache/${node}/ticket_types_${eventId}_${hourId}.json?v=${hashVersion}`;
  }

  async getTicketStatus(ticketId) {
    const { data } = await this.axios.get(`${this.checkoutUrl}.1/payment/validate/${ticketId}`);
    return data;
  }

  async getTransactionDetail(payload, token) {
    const headers = token ? { Authorization: token } : {};
    const { data } = await this.axios.post(`${this.nodeUrl}/my-tickets`, payload, { headers });
    return data;
  }

  async getSeatsStringByBlockId(payload) {
    const {
      data: { data },
    } = await this.axios.post(`${this.nodeUrl}/theater/event-seats-block`, payload);
    return data;
  }

  async getSeatsBuyed(payload) {
    // const payload = {
    //   activityId: this.eventData.activity_id,
    //   dateHourId: this.currentType.adhId,
    // };
    // const { data: { data } } = await this.axios.post('/theater/event-seats-busy', payload);
    const {
      data: { data },
    } = await this.axios.post(`${this.nodeUrl}/theater/event-seats-busy`, payload);
    return data;
  }

  async seatVerifyAndReserved(payload) {
    // const payload = {
    //   activityId: this.eventData.activity_id,
    //   dateHourId: this.currentType.adhId,
    //   typesAvailable: this.typesIds,
    //   seat: data.id,
    //   reserveSeat: 1,
    //   reserveSeatAnnulled: 1,
    //   reserveSeatToken: reserveToken,
    // };
    // const { data: { data } } = await this.axios.post('/theater/event-seat-valid', payload);
    const {
      data: { data },
    } = await this.axios.post(`${this.nodeUrl}/theater/event-seat-valid`, payload);
    return data;
  }

  async reservateMinistry(payload, slug = 'joinnus') {
    const { data } = await this.axios.post(`${this.nodeTicketingUrl}/v1/${slug}/ticketing/reservation`, payload);
    return data;
  }

  async solicitRepayment(payload) {
    const data = await this.axios.post('/refunds/store-clients-data', payload);
    return data;
  }

  async getInfoRepayment(ticketId) {
    const { data } = await this.axios.get(`/refunds/available?ticketId=${ticketId}`);
    return data;
  }

  async refundCodes(payload) {
    const { data } = await this.axios.post('/transactions/refund-codes', payload);
    return data;
  }

  async getCities(userId) {
    const data = await this.axios.get(`/cities/user/${userId}`);
    return data;
  }

  async getCountries() {
    const data = await this.axios.get('/countries');
    return data;
  }

  async getCitiesByCountry(slug) {
    let cities = [];
    try {
      const key = 'cities';
      const localData = window.localStorage.getItem(key);
      if (localData) {
        cities = JSON.parse(localData);
      } else {
        const data = await this.axios.get(`/${slug}/cities`);
        cities = data.data;
        window.localStorage.setItem(key, JSON.stringify(data.data));
      }
      return {
        data: cities,
        status: true,
      }
    } catch (error) {
      return {
        data: cities,
        status: false,
      }
    };
  }

  async setUser(payload) {
    const { data } = await this.axios.put('/user', payload);
    return data;
  }

  async verifySession(id) {
    const query = `
    query {
      session (id: "${id}") {
        user {
          id
          firstName
          lastName
          email
          profilePicture
          documentType
          document
          phone
          isAdmin
          hasPreferences
        }
        loggedIn
      }
    }
    `;
    try {
      const {
        data: {
          data: { session },
        },
      } = await axios({
        url: this.graphApi,
        method: 'post',
        data: { query },
      });
      return session;
    } catch (error) {
      return error;
    }
  }

  async getMerchandises(slugPartner) {
    const query = `
    query {
      merchandises(limit: 8, page: 1, organizer: "${slugPartner}") {
        data {
          id
          userId
          name
          description
          images
          isGlobal
          category {
            id
            name
          }
          currency {
            iso
            symbol
          }
          type
          sku
          price
          offerPrice
          stock
          variations {
            data {
              id
              sku
              price
              offerPrice
              images
              searchCode
              quantity
              quantitySold
            }
          }
          specifications {
            data {
              key
              value
            }
          }
        }
        totalCount
        organizer
      }
    }
    `;
    try {
      const {
        data: {
          data: { merchandises },
        },
      } = await axios({
        url: this.graphApi,
        method: 'post',
        data: { query },
      });
      return merchandises;
    } catch (error) {
      return error;
    }
  }

  async getDataHome(slug = 'all,v3') {
    const query = `
      query dataHome ($slug: String){
        trends(limit: 20) {
          id
          title
          description
          url
          media {
            url
          }
        }
        banners(limit: 15, homepageSlug: $slug) {
          ...fBanners
        }
      }
      fragment fBanners on Banner {
        id
        url
        description
        media {
          url
        }
        mobMedia {
          url
        }
        homepage
      }`;
    try {
      const {
        data: {
          data: { banners },
        },
      } = await axios({
        url: this.graphApi,
        method: 'post',
        data: { query, variables: { slug } },
      });
      return banners;
    } catch (error) {
      return error;
    }
  }

  async getContestants(token, payload) {
    this.nodeApi.defaults.headers.common.Authorization = token;
    const { data } = await this.nodeApi.get('/fpf/contestants', { params: payload });
    return data;
  }

  async reservate(payload) {
    const { data } = await this.axios.post(`${this.checkoutUrl}/reservate`, payload);
    return data;
  }

  async setContestants(payload) {
    const { data } = await this.axios.post(`${this.nodeUrl}/fpf/contestants`, payload);
    return data;
  }

  async updateContestants(payload) {
    const { data } = await this.axios.put(`${this.nodeUrl}/fpf/contestants`, payload);
    return data;
  }

  async updateUserToken(payload) {
    const { data } = await this.axios.put(`${this.nodeUrl}/fpf/updateUserToken`, payload);
    return data;
  }

  async updateMissingTokens(payload) {
    const { data } = await this.axios.put(`${this.nodeUrl}/izipay/update-missing-tokens`, payload);
    return data;
  }

  async getStockProduct(id, variation) {
    const { data } = await this.axios.get(`/products/${id}?variationId=${variation}`);
    return data;
  }

  async setDelivery(payload) {
    const { data } = await this.axios.post(`${this.checkoutUrl}/payment/delivery`, payload);
    return data;
  }

  async verifyDniCoupon(payload) {
    const { data } = await this.axios.post('/services-external/club/comercio', payload);
    return data;
  }

  async verifyCouponByEvent(eventId, payload) {
    const { data } = await this.axios.post(`/PE/events/${eventId}/discount-code?origin=online`, payload);
    return data;
  }

  async setCookies(payload, token) {
    if (!token) {
      return { success: false };
    }
    const headers = token ? { cookie_joinnus: token } : {};
    const { data } = await this.profileUrl.post('/users/cookies', payload, {
      headers,
    });
    return data;
  }

  async getEventDates(id) {
    const {
      data: { multidates },
    } = await this.axios.get(`/PE/events/${id}/dates?source=web`);
    return multidates;
  }

  async getDeliveryZones(id) {
    const query = `
      query {
        merchandiseDeliveryZones(store: ${id}) {
          data {
            id
            name
            methods
            locations
          }
          totalCount
          ubigeo
        }
      }
    `;
    const { data } = await axios({
      url: this.graphApi,
      method: 'post',
      data: { query },
    });
    return data.data.merchandiseDeliveryZones;
  }

  async getStoreInfo(payload) {
    const { data } = await this.axios.post('/merchandise/stores', payload);
    return data;
  }

  async newUserAddress(payload) {
    const { data } = await this.axios.post('/addresses', payload);
    return data;
  }

  async sendLoginCode ({ type = 'email', user }) {
    const OPT_TYPE = 'otp-login-two-auth';
    const types = {
      email: 'token-login-two-auth',
      'alt-email': 'token-login-two-auth-email-alternative',
      sms: OPT_TYPE,
      whatsapp: OPT_TYPE,
    };
    const typeKey = types[type];
    const { token } = user;
    const params = {
      type: typeKey,
      token,
    };
    const headers = {
      'x-encrypt-version': 2
    };
    if (['sms', 'whatsapp'].includes(type)) {
      const body = {
        code: user.phoneCode,
        phone: user.phone.toString(),
        option: 'otp',
        type: typeKey,
        token,
      };
      const encripted = await encryptData(JSON.stringify(body))
      const dataFinal = btoa(String.fromCharCode(...encripted))
      const { data } = await this.axios.post(`${profileUrl}/v2/joinnus/auth/phone/send/${type}`, { data: dataFinal }, { headers });
      return data;
    }
    const encripted = await encryptData(JSON.stringify(params))
    const dataFinal = btoa(String.fromCharCode(...encripted))
    try {
      const { data } = await this.axios.post(`${profileUrl}/v1/joinnus/auth/generate/token`, { data: dataFinal }, { headers });
      return data;
    } catch (error) {
      // eslint-disable-next-line
      console.error(error);
      throw error;
    }
  }

  async validateLoginCode ({ type = 'email', code, token }) {
    const VERIFY_TYPE = 'verify-login-two-auth';
    const types = {
      email: VERIFY_TYPE,
      'alt-email': 'verify-login-two-auth-email-alternative',
      phone: VERIFY_TYPE,
    };
    const body = {
      otp: code,
      type: types[type],
      token,
    };
    const headers = {
      'x-encrypt-version': 2
    };
    const encripted = await encryptData(JSON.stringify(body))
    const dataFinal = btoa(String.fromCharCode(...encripted))
    const { data } = await this.axios.post(`${profileUrl}/v2/joinnus/auth/verify-otp`, { data: dataFinal }, { headers });
    return data;
  }

  async getParticipants(token) {
    const headers = {
      cookie_joinnus: token,
    }
    const { data } = await this.profileUrl.get('/joinnus/profile/participants',{ headers });
    return data;
  }

  async setParticipant(body, token) {
    const captcha = await getToken()
    const headers = {
      captcha,
      cookie_joinnus: token,
      'x-encrypt-version': 2
    }
    const encripted = await encryptData(JSON.stringify(body))
    const dataFinal = btoa(String.fromCharCode(...encripted))
    const { data } = await this.profileUrl.post('/joinnus/profile/participants', { data: dataFinal }, { headers });
    return data;
  }

  async searchParticipant(document, token) {
    const captcha = await getToken()
    const headers = {
      captcha,
      cookie_joinnus: token,
    }
    const { data } = await this.profileUrl.get(`/joinnus/profile/participants/document/${document}`, { headers });
    return data;
  }

  async getUbigeoCountry() {
    const headers = {
      captcha: await getToken(),
    };
    const { data } = await this.apiConfigs.get('/ubigeos/country', { headers });
    return data;
  }

  async searchUbigeos(search = '', isoCode = 'PE', token) {
    const url = `/ubigeos?search=${search}&isoCode=${isoCode}&level=3`
    const headers = {
      captcha: 'jnus-web',
      cookie_joinnus: token
    }
    const {data} = await this.profileUrl.get(url, { headers });
    return data
  }

  async logout (token) {
    const { data } = await this.axios.post(`${this.apiUrl}/auth/logout`, {
      sessionId: token
    }, { withCredentials: true })
    return data
  }

  async setCookieJoinnus2(payload){
    const { data } = await this.axios.post(`${this.apiUrl}/auth/session-cookie`,
      payload
    , { withCredentials: true})
    return data
  }

  // eslint-disable-next-line class-methods-use-this
  getAlianzaLima(){
    return `${s3Url}joinnus.com/prime/alianzalima/json/alianza-${VUE_APP_ENV}.json?v=${VUE_APP_VERSION}`;
  }
}

export default new Api();
